module.exports = __webpack_public_path__ + "static/img/Bz_mzjg_icon.png";